<template>
  <div class="max-w-lg m-auto my-16">

    <BrokerpadLogo />

    <form v-on:submit.prevent class="bg-white mt-6 rounded shadow-lg border" autocomplete="on">

      <div class="flex flex-wrap">
        <div class="w-1/2">
          <a href="#"
            @click.prevent="loginAs = 'broker'"
            :class="{ 
            'block p-8 text-base text-gray-700 flex items-center' : true, 
            'bg-white' : loginAs == 'broker', 
            'bg-gray-200 border-b border-r border-gray-300' : loginAs != 'broker' 
          }">

            <img src="https://img.icons8.com/cotton/64/000000/business-group.png" class="inline w-8 mr-3" />
            Sign in as a <span class="font-semibold ml-2 underline">Broker</span>
          </a>
        </div>

        <div class="w-1/2">
          <a href="#"
            @click.prevent="loginAs = 'client'"
            :class="{ 
            'block p-8 text-base text-gray-700 flex items-center' : true, 
            'bg-white' : loginAs == 'client', 
            'bg-gray-200 border-b border-l border-gray-300' : loginAs != 'client' 
          }">

            <img src="https://img.icons8.com/cotton/64/000000/family.png" class="inline w-8 mr-3" />
            Sign in as a <span class="font-semibold ml-2 underline">Client</span>
          </a>
        </div>
      </div>

      <div class="p-8">
        <div class="text-2xl font-light text-gray-700">
          Signing in as a {{ loginAs == 'broker' ? 'Broker' : 'Client' }}
        </div>

        <div class="mt-8">
          <label class="text-base">Email</label>
        </div>

        <div class="mt-2">
          <input type="text"
            v-model="email"
            ref='email'
            class="input-standard"
            name="email"
            :disabled="loading"
            autocomplete='on' />

          <div v-if="errors.email !== null" class="text-red-600 mt-1 text-sm">{{ errors.email }}</div>
        </div>

        <div class="mt-8">
          <label class="text-base">Password</label>
        </div>

        <div class="mt-2">
          <input type="password"
            v-model="password"
            @keyup.enter="submit()"
            class="input-standard"
            name="password"
            :disabled="loading"
            autocomplete='on' />

          <div v-if="errors.password !== null"
            class="text-red-600 mt-1 text-sm">{{ errors.password }}</div>
        </div>

        <div class="mt-10">
          <button
            v-on:click="submit()"
            class="text-white w-full py-4 text-base bg-blue-500 hover:bg-blue-600 font-semibold">
            <template v-if="loading"><img src="/static/img/ajax-loader.gif" class="inline" /></template>
            <template v-else>Login</template>
          </button>
        </div>

        <div class="mt-8 flex items-center">
          <img src="/static/img/icons/icons8-name-small-blue.png" />
          <router-link to="/auth/register" class="ml-2 no-underline text-gray-900 hover:underline text-base">
            No account yet? Let's create one.
          </router-link>
        </div>

        <div class="mt-3 flex items-center">
          <img src="/static/img/icons/icons8-remove_key.png" />
          <router-link to="/auth/forgot-password" class="ml-2 no-underline text-gray-900 hover:underline text-base">
            Forgot your password?
          </router-link>
        </div>
      </div>
    </form>

    <div class="pl-8 mt-6">
      <PublicFooter />
    </div>
  </div>
</template>

<script>
  import validator      from "validator"
  import axios          from "axios"
  import PublicFooter   from "@/shared/components/public/Footer"
  import BrokerpadLogo  from '@/shared/components/BrokerpadLogo';

  export default {

    components : {
      BrokerpadLogo,
      PublicFooter
    },

    data() {
      return {
        loading: false,
        choice : null,
        loginAs : 'broker',
        // email     : process.env.NODE_ENV == 'development' ? 'andrewg@brokerpad.com.au' : '',
        // password  : process.env.NODE_ENV == 'development' ? 'password' : '',
        email     : null,
        password  : null,

        errors : {
          email   : null,
          password: null
        }
      }
    },

    mounted() {
      this.$refs.email.focus()
      document.body.className = 'bg-gray-100'
    },

    created() {
      this.choice = Math.floor(Math.random() * (4 - 0)) + 0
    },

    methods : {

      submit() {
        this.errors = {
          email   : null,
          password: null
        }

        let email    = this.email
        let password = this.password
        let valid    = true

        if(email == null || !validator.isEmail(email)) {
          this.errors.email = "Please type a valid email."
          valid = false;
        }

        if(password == null || password.length == 0) {
          this.errors.password = "Please type a valid password."
          valid = false;
        }

        if(valid) {
          this.loading = true

          axios.post(process.env.VUE_APP_API_URL + '/api/auth/login', {
            email   : email.toLowerCase().trim(),
            password: password,
            timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
            loginAs : this.loginAs
          }).then(response => {

            // v2 redirect to update the password
            if(response.data.redirect != null && response.data.redirect == 'check-mfa' && response.data.userId != null) {
              this.$router.push({
                name  : 'auth-check-mfa',
                params: {
                  userId : response.data.userId
                }
              })
            }

            else {

              if (response.data.token == null) {
                throw new TypeError('JWT Token is null')
              }

              localStorage.setItem("bp-broker-jwt", response.data.token)
              this.$store.commit('setIsLoggedIn', true)

              // check if we have redirectUrl
              if(this.$store.state.redirectUrl) {
                this.$router.push(this.$store.state.redirectUrl)
                this.$store.commit('setRedirectUrl', null)
              }

              else {

                this.getUser({
                  force : true
                }, (user) => {

                  if(user != null) {

                    if(this.loginAs == 'client') {
                      this.$router.push({
                        name  : 'client-home', 
                        params: {
                          clientId : user.client.id
                        }
                      })
                    }

                    else {
                      this.$router.push({
                        name : user.broker.should_show_landing == 1 ? 'broker-home' : 'client-list'
                      })
                    }
                  }

                })
              }
            }

          }).catch(e => {
            console.log(e)
            this.loading      = false
            this.errors.email = "Authentication failed. Please try again."
          })
        }
      },
    },
  }
</script>